
import React from "react";
//import Button from "../common/Button";
import styles from "../css/PAS.module.css";



function PAS( { data }: any ) { // TODO: TYPE (IPAS ?? Need in scope...)

  console.log( "PAS DATA...", data );

  return (
    <section className={styles.pasSection}>
      <div className={styles.problem}>
        <h2>{data.problem.title}</h2>
        <p>{data.problem.description}</p>
        {data.problem.image && (
          <img 
            src={data.problem.image.src} 
            alt={data.problem.image.alt} 
            className={styles.problemImage}
          />
        )}
      </div>
      <div className={styles.agitation}>
        <h2>{data.agitation.title}</h2>
        <p>{data.agitation.description}</p>
        <ul className={styles.painPoints}>
          {data.agitation.painPoints.map( (point: string, index: number) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      <div className={styles.solution}>
        <h2>{data.solution.title}</h2>
        <p>{data.solution.description}</p>
        <ul className={styles.benefits}>
          {data.solution.benefits.map( (benefit: string, index: number) => (
            <li key={index}>{benefit}</li>
          ))}
        </ul>
        {data.solution.image && (
          <img 
            src={data.solution.image.src} 
            alt={data.solution.image.alt} 
            className={styles.solutionImage}
          />
        )}
      </div>
      <div className={styles.ctaContainer}>
        {/*<Button {...data.primaryCTA} />*/}
      </div>
    </section>
  );
};

export default PAS;
